import React, { FC } from "react";
import styled from "styled-components";
import getUserData from "../utils/getUserData";

export const CheckoutStepperWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	justify-content: flex-start;
	align-items: stretch;
	align-content: center;
	margin: 15px;
	padding-bottom: 36px;
`;

export const CheckoutStepperHeader = styled.div`
	border-radius: 8px 8px 0px 0px;
	background: ${props => props.theme.colors.lightGrayVitat || "#f2f2f8"};
	border-bottom: 5px solid ${props => props.theme.colors.brownVitat || props.theme.colors.primary};
	padding-top: 8px;
	padding-left: 12px;
	padding-right: 12px;
	padding-bottom: 5px;
	font-family: Livvic;
	font-style: normal;
	font-weight: 600;
	font-size: 13px;
	line-height: 165.5%;
	color: ${props => props.theme.colors.blackVitat || "#002b49"};
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: space-between;
	align-items: center;
	align-content: center;
	p {
		margin: 0px;
	}
`;

export const CheckoutStepperBody = styled.div`
	background: ${props => props.theme.colors.lightGrayVitat || "#f2f2f8"};
	padding-top: 10px;
	padding-left: 22px;
	padding-right: 25px;
	padding-bottom: 22px;
	line-height: 165.5%;
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	justify-content: flex-start;
	align-items: flex-start;
	align-content: center;
`;

export const InputLabel = styled.p`
	font-family: Livvic;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	line-height: 165.5%;
	color: #000000;
	margin-bottom: 8px;
	text-align: left;
`;

export const TermsLabel = styled.p`
	font-family: Livvic;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	line-height: 165.5%;
	color: #000000;
	margin-bottom: 8px;
	text-align: center;
`;

export const TermsWrapper = styled.div`
	width: calc(100% - 30px);
	display: flex;
	align-items: center;
	flex-direction: row;
	margin-left: 15px;
	margin-right: 15px;
`;

interface FormRowProps {
	gap?: number;
	margin?: number;
}

export const FormRow = styled.div<FormRowProps>`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: flex-start;
	align-items: flex-start;
	align-content: flex-start;
	gap: ${props => props.gap || 0}px;
	margin-top: ${props => props.margin || 0}px;
	margin-bottom: ${props => props.margin || 0}px;
`;

export const FormFieldWrapper = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	justify-content: flex-start;
	align-items: flex-start;
	align-content: flex-start;
`;

export interface PersonalDataInterface {
	nomeCompleto: string;
	nomeSocial: string;
	dataNascimento: string;
	sexoBiologico: "Feminino" | "Masculino" | "";
	cpf: string;
	celular: string;
}

export interface BuyDetailsInterface {
	nome: string;
	numero: string;
	validade: string;
	cvv: string;
	bandeira: string;
	mesValidade: string;
	anoValidade: string;
}

export interface StepFormProps {
	carregaProximoPasso: (payload: PersonalDataInterface | BuyDetailsInterface | null) => void;
}

export const FooterButtonWrapper = styled.div`
	margin-bottom: -20px;
	width: 100%;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: center;
	align-items: center;
	align-content: center;
`;

export const CheckoutStepperFooter = styled.div`
	border-radius: 0px 0px 8px 8px;
	background: ${props => props.theme.colors.lightGrayVitat || "#f2f2f8"};
	padding-top: 8px;
	padding-left: 12px;
	padding-right: 12px;
	font-family: Livvic;
	font-style: normal;
	font-weight: 600;
	font-size: 13px;
	line-height: 165.5%;
	color: #002b49;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: space-between;
	align-items: center;
	align-content: center;
	p {
		margin: 0px;
	}
`;

export const YourBuyWrapper = styled.div`
	width: 100%;
	height: fit-content;
	background: ${props => props.theme.colors.lightGrayVitat || "#f2f2f8"};
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	justify-content: flex-start;
	align-items: flex-start;
	align-content: center;
	padding-bottom: 22px;
`;

export const YourBuyRow = styled.div`
	background: ${props => props.theme.colors.lightGrayVitat || "#f2f2f8"};
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: flex-start;
	align-items: center;
	align-content: center;
	margin-left: 22px;
`;
const DottedLine = styled.div`
	border-bottom: 2px dashed #8c8fa0;
	display: inline-block;
	flex-grow: 1;
`;

const ItemBuyWrapper = styled.div`
	width: calc(100% - 44px);
	display: flex;
	align-items: center;
	flex-direction: row;
	margin-left: 22px;
	margin-right: 22px;
`;

const ItemBuyText = styled.p`
	margin: 0px;
	font-family: Livvic;
	font-style: normal;
	font-size: 12px;
	line-height: 165.5%;
	letter-spacing: 0.005em;
	color: #000000;
`;

const ItemBuyLabel = styled(ItemBuyText)`
	margin-right: 5px;
`;

const ItemBuyValor = styled(ItemBuyText)`
	margin-left: 5px;
`;

interface ItemBuyProps {
	descricao: string;
	valor?: number;
	quantidade: number;
}

export const ItemBuy: FC<ItemBuyProps> = ({ descricao, quantidade, valor }) => {
	const { skipPayment } = getUserData();

	return (
		<ItemBuyWrapper>
			<ItemBuyLabel>
				<b>{quantidade}x</b> {descricao}
			</ItemBuyLabel>
			<DottedLine />
			{!skipPayment && (
				<ItemBuyValor>
					{valor !== undefined &&
						valor.toLocaleString("pt-br", {
							style: "currency",
							currency: "BRL",
						})}
				</ItemBuyValor>
			)}
		</ItemBuyWrapper>
	);
};
